import { CircularProgress } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

const Notification = () => {
  const {
    notification: { active, loading, error, message },
  } = useSelector((state) => state.styles);

  return (
    <div
      className={`notification ${active === "unset" ? "" : active ? "notification-open" : "notification-closed"} ${
        !loading ? (error ? "bg-red" : "bg-green") : ""
      }`}
    >
      {!loading ? (
        error ? (
          <CancelRoundedIcon className="icon" />
        ) : (
          <CheckCircleRoundedIcon className="icon" />
        )
      ) : (
        <CircularProgress className="spinner" />
      )}
      <p className="message">{message}</p>
    </div>
  );
};

export default Notification;
